import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'cedato-manage-rtb-partners',
  templateUrl: './manage-rtb-partners.component.html',
  styleUrls: ['./manage-rtb-partners.component.scss'],
})
export class ManageRtbPartnersComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public gridCustomSettings: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public emptyDataSettings: any;
  public gridFilters: any;
  public getBudgetsObservable: any;
  public subscriptions: Array<any>;

  constructor(
    public httpService: HttpService,
    public gridService: GridService,
    public sharedService: SharedService,
    public userService: UserService,
    public ga: GoogleAnalyticsService,
    public router: Router,
    public dictionaryService: DictionaryService
  ) {
    this.columnsSettings = [
      { key: 'name', label: 'NAME', width: 250, filterType: 'INPUT' },
      { key: 'endpoint', label: 'ENDPOINT', width: 250, filterType: 'INPUT' },
    ];
    this.subscriptions = [];
    this.data = [];
    this.gridFilters = [];
  }

  ngOnInit(): void {
    this.initialize();

    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.initialize();
        }
      })
    );
    this.sharedService.setPageTitle('MANAGE_CAMPAIGNS');
  }

  ngOnDestroy(): void {}

  initialize(): void {
    if (this.userService.getFeatureState('rtb_demand')) {
      this.getRTBPartnersList();
    } else {
      this.router.navigate(['/']).then(() => {
        return;
      });
    }
  }

  getRTBPartnersList(): void {
    if (this.getBudgetsObservable) {
      this.getBudgetsObservable.unsubscribe();
    }

    const params: any = {};
    this.isLoading = true;

    this.getBudgetsObservable = this.httpService.post('vdsp_ws/getRtbPartner', params).subscribe(
      (response: any) => {
        const data = response.data;
        for (let i = 0; i < data.length; i++) {
          data[i].$$id = +data[i].id;
          data[i].endpoint = data[i].us_west_endpoint ? data[i].us_west_endpoint : data[i].us_east_endpoint;
          data[i].$$link = `${data[i].$$id}`;
          data[i].$$actions = [{ type: 'EDIT', link: true }];
        }
        this.data = data;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        this.isError = true;
      }
    );
  }

  createNewRTBPartner(): void {
    this.router.navigate(['rtb-partners/new'], {}).then(() => {
      return;
    });
  }
}
